const english = {
  Common: {
    money: '{{amount, currency}}',
    moneyWithTrailingZeros: '{{amount, currency(displayTrailingZeros: true)}}',
    moneyWithoutDecimals: '{{amount, currency(displayDecimals: false)}}',
    contactUs: 'Contact us',
    back: 'Back',
    ok: 'Ok',
    close: 'Close',
    retry: 'Retry',
    feedback: 'Feedback',
    count_ordinal_one: '{{count}}st',
    count_ordinal_two: '{{count}}nd',
    count_ordinal_few: '{{count}}rd',
    count_ordinal_other: '{{count}}th',
    loading: 'Loading',
    otpInputLabel: 'Verification code',
  },
  Metadata: {
    title: 'Fairlo: Fair Finance',
    description:
      'Credit that works for your everyday life, no matter how your situation changes. Apply for your credit line today!',
  },
  CommonFormLabels: {
    email: 'E-mail',
    mobile: 'Mobile number',
  },
  Button: {
    clear: 'Ok',
    tryAgain: 'Try again',
  },
  Header: {
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    aboutUs: 'About Fairlo',
    customerService: 'Contact us',
    commonQuestions: 'Help centre',
    paymentPlan: 'My repayment plan',
    userProfile: 'My details',
    apply: 'Apply',
    login: 'Log in',
    home: 'Home',
    logout: 'Log out',
    cookieSettings: 'Cookie settings',
    toggleContactSupport: 'Toggle contact support',
    chatWidgetLoadError: 'Chat is currently unavailable. Please try again later.',
  },

  Modal: {
    AgreementHasDebt: {
      title: 'Repay your outstanding balance',
      text: 'Before you can end this agreement you need to ensure that your outstanding balance is £0. Your outstanding balance is {{amount, currency}}.',
      button: 'Repay now',
    },
    RepayOutstandingBalance: {
      title: 'Repay your outstanding balance',
      info: 'Before you can end this agreement you need to ensure that your outstanding balance is £0.',
      button: 'Repay now',
    },
    LastPaybackStillProcessing: {
      title: 'You have a remaining balance',
      info: 'Unfortunately, you cannot close your account at the moment because your monthly payment is still being processed. Please come back once the payment has been completed. It can take up to one banking day from when payment is withdrawn from your account until it is fully processed by us.',
      button: 'Done',
    },
    ApplicationExistingUser: {
      title: 'Welcome back!',
      info: 'We can see that you already have a Fairlo account.',
      action: 'Login',
    },
    ApplicationExpired: {
      title: 'Your application has expired',
      info: 'Please complete the application form to reapply.',
      button: 'Reapply now',
    },
    DepositFail: {
      title: 'Something has gone wrong',
      info: "Your additional repayment didn't go through, please try again or make a manual repayment.",
      payManually: 'Pay manually',
      tryAgain: 'Try again',
    },
    DepositSuccess: {
      title: 'Repayment successful',
      info: 'For a full summary go to your Repayment Plan view. Your outstanding balance will be updated once the repayment has been received.',
      depositAmount: 'Total repaid',
      monthlyAmount: 'New monthly repayment',
      button: 'Done',
    },
    DirectDebitChargeInProgress: {
      title: 'Your Direct Debit is being processed',
      info: 'As soon as your monthly repayment of {{chargeInProgressAmount, currency}} has gone through successfully, you will be able to make withdrawals as usual again. Thanks for your patience.',
    },
    DirectDebitMandateNotFound: {
      title: 'Your Direct Debit mandate is missing',
      info: 'Your Direct Debit has been removed, you will be able to make further withdrawals once you’ve set this up. To do this please follow the notification on the home screen.',
    },
    DirectDebitSetupFailed: {
      title: 'Something has gone wrong',
      info: 'Your Direct Debit Mandate wasn’t submitted please try again.',
    },
    BankAccountUnableToValidate: {
      title: 'Unable to validate your account',
      info: 'Please check you entered your account details correctly.',
    },
    BankAccountNotSupported: {
      title: "Your account isn't supported",
      info: "We were unable to validate your account details because your account isn't supported. Please try a different account.",
    },
    BankAccountManualApproval: {
      title: 'Unable to verify your nominated account',
      body: "We're sorry, but we haven't been able to automatically verify the account you nominated for withdrawals and repayments.",
      requirementsTitle: 'Your nominated account must be:',
      requirement1: 'A UK bank or building society account.',
      requirement2: 'Held in your name and registered at your residential address.',
      requirement3: 'Able to make electronic payments and Direct Debits.',
      requirement4: 'The account your salary is paid into.',
      instructionsTitle:
        'Please reply to the email we have just sent with the following documents so we can manually verify your account:',
      document1:
        'Your latest bank statement in PDF format showing all account details including name, address, sort code and account number',
      document2: 'A picture your driving licence (front), or passport (picture page)',
      footer:
        "Check your spam folder or contact us at <customerServiceMail></customerServiceMail>, if you haven't received our email.",
      button: 'Got it',
    },
    ConfirmWithdrawal: {
      title: 'Confirm your withdrawal of {{withdrawalAmount, currency}}?',
      info: 'Transferred into your nominated account.',
      infoWithFees:
        'Here is your updated monthly repayment amount and your new outstanding balance that includes a setup fee of {{setupFee, currency}} and a withdrawal fee of {{withdrawalFee, currency}}.',
      infoTitle1: 'Monthly repayment',
      infoTitle2: 'New outstanding balance',
      button: 'Withdraw {{withdrawalAmount, currency}}',
    },
    OverdueChargeInProgress: {
      title: 'Monthly repayment overdue',
      info: 'Until your Direct Debit has successfully completed you won’t be able to make further withdrawals.',
    },
    Reapply: {
      title: 'Please reapply to proceed',
      button: 'Reapply now',
    },
    ConfirmManualDeposit: {
      title: 'Over to you!',
      info: 'Your outstanding balance will be updated as soon as we receive your manual additional repayment. Once you have made the bank transfer it can take up to 5 working days to update.',
      button: 'Ok',
    },
    WithdrawalBlocked: {
      title: '<private>{{username}}</private>, unfortunately you cannot make withdrawals at the moment',
      info: "We at Fairlo take responsible lending seriously and our assessment is that it would not be responsible to allow more withdrawals. We cannot currently know when you will again be able to make withdrawals, but promise to notify you as soon as the situation changes. Until then, it's super important that you stick to your payment plan. Your friends at Fairlo",
      contactUs: 'Contact us',
      clear: 'Ok',
    },
    WithdrawalInProgress: {
      title: "It is on it's way, but the transaction is taking a little longer than usual",
      info: 'Sometimes transactions can take up to 2 hours, by typically this is much faster. Do not hesitate to get in touch if you have any questions.',
      clear: 'Ok',
    },
    WithdrawalNotPossible: {
      title: 'Remaining limit below minimum withdrawal',
      info: 'To do a withdrawal you need to have at least {{minimumWithdrawalAmount, currency}} in unused credit.',
      button: 'Ok',
    },
    WithdrawalAmountInvalid: {
      title: 'Invalid amount',
      info: 'The amount you chose is no longer available. Please select another amount.',
      clear: 'Ok',
    },
    ConfirmEndAgreement: {
      title: 'Are you sure?',
      info: 'Are you sure you want to end your agreement, this can’t be reversed and you will lose access to your Fairlo account.',
      button: 'End agreement',
    },
    WithdrawalFail: {
      title: 'Something has gone wrong',
      info: "Your withdrawal wasn't successful, please try again.",
      contactUs: 'Contact us',
      tryAgain: 'Try again',
    },
    WithdrawalSuccess: {
      title: 'Your money is on its way',
      info: 'For a full summary go to your Repayment Plan view. Don’t forget you can reduce the interest due by increasing your monthly repayment.',
      fairnessReceiptButton: 'View Fairness Receipt',
      button: 'Change monthly repayment',
    },
    ChangeMonthlyPaymentSuccess: {
      title: 'Your monthly repayment is updated',
      info: 'For a full summary go to your Repayment Plan view.',
      listItemTitle: 'Monthly amount',
      numberOfInstallmentsLabel: 'Repayment duration',
      numberOfInstallmentsValue_one: '{{count}} month',
      numberOfInstallmentsValue_other: '{{count}} months',
      button: 'Done',
    },
    ChangeMonthlyPaymentFailed: {
      title: 'Something has gone wrong',
      info: 'We couldn’t update your monthly repayment. Please try again.',
      button: 'Ok',
    },
    OverduePayment: {
      title: 'An amount is overdue',
      info: 'This includes all overdue monthly repayments and any additional interest accrued on the balance up to today due to late repayment',
      infoItemTitle1: 'Overdue monthly repayments',
      infoItemTitle2: 'Additional interest accrued',
      infoItemTitle3: 'Total overdue amount due',
      button: 'Pay {{amount, currency}}',
    },
    TermsAndConditionsUpdated: {
      title: 'We’ve updated our Terms and Conditions',
      info: 'You don’t need to do anything, but if you’d like, you can click the button below to read the latest version.',
      button1: 'Read more',
      button2: 'Ok',
    },
  },
  ErrorInfo: {
    title: 'Oops! Something went wrong',
    text: 'Please go back to the home page and try again',
    button: 'Take me home',
  },

  FormErrors: {
    required: 'This is required',
    alphabeticalOnly: 'Please only use letters',

    positiveOnly: 'This cannot be negative',
    invalidEmail: 'Please enter a valid email address',
    emailTypo: 'Did you mean <suggestion>{{suggestion}}</suggestion>?',
    invalidMobileNumber: 'Please enter your mobile number as +447xxxxxxxxx',
    invalidCurrency: 'Please enter a valid amount',
    maxLength: 'Please only use up to {{length}} characters',
    maxAmount: 'Please check this is correct',
    invalidDigitsLength: 'Must be {{length}} digits',

    numbersInRange: 'Please only use number in the range of {{minValue}} - {{maxValue}}',
  },
  CreditApplicationUK: {
    continueButton: 'Continue',
    personalDetailsForm: {
      title: 'Apply Now',
      firstNameLabel: 'First Name',
      lastNameLabel: 'Last Name',
      birthDayLegend: 'Date of Birth',
      birthYearLabel: 'Year',
      birthYearPlaceholder: 'YYYY',
      birthMonthLabel: 'Month',
      birthMonthPlaceholder: 'MM',
      birthDayLabel: 'Day',
      birthDayPlaceholder: 'DD',
      emailLabel: 'Email address',
      termsAndConditionsText:
        'By continuing you agree to our <privacyNoticeButton>Privacy Notice</privacyNoticeButton> and <termsAndConditionsButton>Terms & Conditions</termsAndConditionsButton>',
      errors: {
        invalidBirthYear: 'Invalid year',
        invalidBirthMonth: 'Invalid month',
        invalidBirthDay: 'Invalid day',
        invalidDate: 'Please enter a valid date',
      },
    },
    addressForm: {
      title: 'Address Details',
      heading1: 'We need 3 years UK address history.',
      heading2: 'Please provide your previous address.',
      heading3: 'We just need one more previous address.',
      buildingNumberLabel: 'Building number',
      buildingNameLabel: 'Building name',
      streetLabel: 'Street',
      postCodeLabel: 'Post Code',
      townLabel: 'Town / City',
      longTimeAddressLegend: 'Have you lived here since {{date}}?',
      longTimeAddressYes: 'Yes',
      longTimeAddressNo: 'No',
      autocompleteLabel: 'Address',
      autocompletePlaceholder: 'Start typing your address',
      switchToManualAddress: 'Enter address manually',
      selectAnotherAddress: 'Select another address',
      editAddress: 'Edit address',
      errors: {
        invalidPostCode: 'Please enter a valid post code',
        buildingNameOrNumberRequired: 'Please enter a building name or number',
        residentialAddressRequired: 'Please enter a residential address',
        editAddressManually: 'Please edit the address manually',
        serviceError: 'Something has gone wrong. Please enter an address manually.',
      },
    },
    incomeForm: {
      title: 'Income',
      employmentStatusLegend: 'Employment Status',
      employmentStatusOptionFullTime: 'Full-time',
      employmentStatusOptionPartTimeFixedIncome: 'Part-time - Fixed Salary',
      employmentStatusOptionPartTimeVariableIncome: 'Part-time - Variable Pay',
      employmentStatusOptionSelfEmployed: 'Self Employed',
      employmentStatusOptionRetired: 'Retired',
      employmentStatusOptionUnemployed: 'Unemployed',
      monthlyIncomeLegend: 'Enter the amount paid into your account each month.',
      monthlyIncomeLabel: 'Your monthly income after tax',
      monthlyIncomeWarning:
        'Your income looks high, check you have entered the amount paid into your account each month.',
      peopleContributingToHouseholdLegend:
        'How many adults in your household earn income and contribute to bills?',
      peopleContributingToHouseholdOption1: 'Only me',
      peopleContributingToHouseholdOption2: 'Two',
      peopleContributingToHouseholdOption3: 'Three',
      peopleContributingToHouseholdOption4: 'Four+',
    },
    outgoingsForm: {
      title: 'Outgoings',
      subtitle: 'Please enter the amount which you personally pay each month for the following outgoings.',
      monthlyRentLabel: 'Monthly rent / mortgage',
      monthlyLoanLabel: 'Monthly loan or credit repayments',
      monthlyOutgoingsLabel: 'Other monthly outgoings',
      numberOfDependentsLegend: 'How many dependents do you have?',
      numberOfDependentsOption0: '0',
      numberOfDependentsOption1: '1',
      numberOfDependentsOption2: '2',
      numberOfDependentsOption3: '3+',
      footerText: "We will perform a soft search \nthis won't impact your credit score.",
      submitButton: 'Submit',
    },
    status: {
      loaderText: 'We’re just assessing your application. It will only take a few moments.',
    },
    manualApproval: {
      title: 'We need a few more details',
      text1:
        'You are almost there, we just need a few more details before we can proceed with your application.',
      text2: 'Please reply to the email we have just sent, within 5 days, with the following documents:',
      bullet1:
        'A statement from the last 3 months showing all account details including name, address, sort code and account number',
      bullet2: 'A picture your driving licence (front), or passport (picture page)',
      text3:
        'Check your spam folder or <contactButton>contact us</contactButton>, if you haven’t received our email.',
      button: 'Got it',
      reason: {
        selfEmployedIncomeVerification: 'Your 2 most recent SA302 tax returns',
        partTimeVariableIncome: 'Your last 3 payslips',
        politicallyExposedPerson: 'A payslip from the last 3 months',
      },
    },
    manualApprovalError: {
      title: 'We need a few more details',
      text1: 'We just need a few more details before we can proceed with your application.',
      text2:
        'Please check your emails and reply to the email from <emailLink /> with the documents requested.',
      text3:
        'Check your spam folder or <contactButton>contact us</contactButton>, if you haven’t received our email.',
      button: 'Got it',
    },
    rejections: {
      title: "Unfortunately, we can't approve you today",
      genericRejectionText: 'While we can’t help you today, we hope we may support you in the future.',
      genericRejectionText2:
        'Our decision is based on the details you provide, along with information we receive from credit reference agencies (Experian and TransUnion), for more information please see our <PrivacyNoticeLink>Privacy Notice</PrivacyNoticeLink> or contact <ExperianLink>Experian</ExperianLink> and <TransUnionLink>TransUnion</TransUnionLink>.',
      overdueRejectionText:
        'This is because you have overdue invoices on your account that need to be settled before you can proceed with any further applications.',
      userBlockedText:
        'This is because you have been blocked from using Fairlo. This could be due to a number of reasons for example; your account going into default, or at your request.',
      questionsText:
        'If you have any questions, or wish to appeal please reach out to our customer support team at <customerServiceMail />.',
      buttonHome: 'Take me home',
      text1: "Based on your income and outgoings you aren't able to afford the minimum repayments.",
      text2: 'This is because your credit score is outside of our lending criteria.',
      text3:
        "Based on your current credit commitments, it wouldn't be responsible for us to provide credit to you at this time.",
      text4: "This is because you don't meet our eligibility requirements for a credit line.",
      action1:
        'Money Helper have an <MoneyHelperLink>online budgeting tool</MoneyHelperLink> to help you assess your finances.',
      action2:
        'Before we (and most other lenders) can offer further credit to you, you will need to catch up with your outstanding credit commitments.',
      action3:
        'If you are struggling to meet your current commitments then Money Helper have some <MoneyHelperTroublesLink>support and guidance</MoneyHelperTroublesLink> which might be useful.',
      action4:
        'You can improve your credit history to improve your chances of being accepted by lenders in the future. Money Helper has more information which may be useful <MoneyHelperImproveLink>here</MoneyHelperImproveLink>.',
      action5:
        'To be eligible for Fairlo you must:\n - be at least 20 years old\n - have a declared annual income of at least £20,000\n - be a current resident in the UK for a minimum of 12 months\n - have a UK bank or building society account able to make repayments by Direct Debit\n - not have any County Court Judgments (CCJs) or Debt Relief Orders against you and/ or be subject to an Individual Voluntary Arrangement (IVA)',
      RecentApplication: {
        text: 'This is because you made a recent application which has been declined.',
        action:
          "Here is a <MoneyHelperLink>link to Money Helper's</MoneyHelperLink> online budgeting tool to help you assess your finances before applying for credit in the future.",
      },
      BlockedStatus: {
        text: 'This is because you have been blocked from using Fairlo. This could be due to a number of reasons for example; your account going into default, or at your request.',
      },
      OverdueStatus: {
        text: 'This is because you have overdue invoices on your account.',
        action: 'These need to be settled before you can proceed with any further applications.',
      },
      CII: {
        action:
          "Here is a <MoneyHelperLink>link to Money Helper's</MoneyHelperLink> online budgeting tool to help you assess your finances and see if you can repay some of your existing debt before applying.",
      },
      Bankrupt_IVA: {
        text: 'This is because you have a Bankruptcy (or similar) on your credit report.',
      },
      CCJ: {
        text: 'This is because you have a CCJ (or similar) on your credit report.',
      },
      Default: {
        text: 'This is because you have a default on your credit report.',
      },
      Delinquency: {
        text: 'This is because you have an overdue account(s) on your credit report.',
      },
      RecentAccountsOpened: {
        text: 'This is because you have opened too many credit accounts elsewhere in the last 12 months.',
        action:
          'This could demonstrate to lenders that you may be struggling to keep up with current commitments.',
        action1:
          'If you are struggling to meet your current commitments then Money Helper have some <MoneyHelperDeptTroubles>support and guidance</MoneyHelperDeptTroubles> which might be useful.',
      },
      ThinFile: {
        text: "This is because your credit report doesn't have enough information on it for us to make a creditworthiness assessment.",
        action:
          'We are looking to expand our offering in the near future, but for now you can build your credit history with services.',
        action1:
          'Money Helper have information on how to improve your credit score <MoneyHelperImproveLink>here</MoneyHelperImproveLink>.',
      },
      BureausUnavailable: {
        text: "Based on the information you provided we can't find your credit report at the credit reference agencies.",
        action: "If you think there's something wrong, please reach out to them through the links below.",
      },
      IncomeVerification: {
        text: 'This is because were unable to verify your income.',
        action:
          'If you have recently changed jobs or salary then it can take time for this to flow through to credit reference agencies.',
      },
    },
    congratulations: {
      title: 'Congratulations',
      subtitle: 'You are approved. Select your credit limit',
    },
    creditLimitForm: {
      title: 'Select your credit limit',
      subTitle:
        'You can withdraw any amount up to your credit limit straight into your bank account at any time. Interest is only charged against the amount you withdraw.',
      submitButton: 'Select',
    },
    broker: {
      title: 'Welcome to your life happens credit buffer',
      text1WithAdvertiser:
        'Thanks for choosing us on {{advertiserName}}, you have been approved for a credit limit of {{creditLimit, currency}} with {{interestRate}} APR. With your credit buffer you:',
      text1WithoutAdvertiser:
        'Thanks for choosing Fairlo, you have been approved for a credit limit of {{creditLimit, currency}} with {{interestRate}} APR. With your credit buffer you:',
      listItems: [
        'Withdraw up to your limit at any time',
        'Pay interest on what you use for the time you use it',
        'Make additional repayments with no fees',
        'Manage your monthly repayments',
      ],
      text2:
        'Complete setting up your credit buffer to withdraw the amount you need and see your full repayment plan.',
      setupFeeInfo:
        'A setup fee of up to 5% will be added to your first withdrawal (depending on your limit), and future withdrawals will have a £15 fee added.',
      button: 'Continue',
    },
    mobileVerification: {
      title: 'Verify your mobile number',
      sendMobileCode: {
        text: 'This allows you to access your account',
        inputLabel: 'Mobile number',
        button: 'Verify',
        mobileNumberNotAccepted:
          'This mobile number cannot be accepted. Please check you entered the number correctly.',
      },
      verifyMobileCode: {
        text1: 'We’ve sent a code to <private>{{mobileNumber}}</private>',
        text2: 'Enter it below',
      },
      rejection: {
        title: "Unfortunately we can't progress your application",
        text1: "This is because we couldn't verify your phone number belonged to you.",
        text2:
          'If you have any questions, you can reach out to our customer support team at <customerServiceMail />.',
        button: 'Take me home',
      },
    },
    documents: {
      title: 'Key documents',
      subTitle: 'Please review and sign the following documents to complete signup.',
      summary: 'Fairlo Summary',
      creditInformation: 'Pre-Contract Credit Information',
      creditAgreement: 'Agreement and T&Cs',
      text: 'We will email you a copy of these documents once signed. To download an unsigned copy click: <summary>Summary</summary>, <creditInformation>PCCI</creditInformation>, <creditAgreement>Agreement</creditAgreement>, <termsAndConditions>T&Cs</termsAndConditions>',
      footerText: 'Fairlo and your repayments will be visible on your credit history.',
      button: 'Confirm',
      form: {
        scrollText: 'Scroll to the bottom to sign',
        signButton: 'Sign',
        backButton: 'Back to agreements',
      },
    },
    success: {
      heading: 'All done!',
      refuseButton: "No, I don't mind if I miss out",
      acceptButton: 'Yes please!',
    },
  },
  ErrorToast: {
    defaultMessage:
      'Something has gone wrong, please try again. If the problem continues contact us at hello@fairlo.co.uk',
    transactionDelayed: 'The transaction has been delayed. Please try again later.',
  },
  Login: {
    LoginForm: {
      title: 'Login to Fairlo',
      emailLabel: 'Email address',
      button: 'Log in',
      emailNotFound: "Sorry this email wasn't found.",
    },
    AccountLocked: {
      title: 'Oops! Your account is locked',
      text1:
        'We have locked your account for 3 hours because you have requested too many one time passcodes.',
      text2: 'You can try to login again in 3 hours.',
      text3: 'This is a security feature to prevent unauthorised access to your account.',
    },
    Authenticate: {
      title: 'Enter the one time passcode',
      text: 'Sent to the mobile phone number on your account.',
    },
  },
  OTPVerification: {
    codeTriesLeft: 'Request new code ({{count}} left)',
    countDown: '{{seconds, relativeTime(second)}}',
    resendButton: 'Resend',
    wrongCode: 'Passcode invalid, please try again or request a new code.',
    codeExpired: 'Passcode expired, please request a new code.',
    maxTriesReached: 'Passcode expired due to too many attempts, please request a new code.',
  },
  BankAccount: {
    DirectDebitSetup: {
      title: 'Set-up your Direct Debit mandate',
      description:
        'This is the instruction to your bank or building society to repay by Direct Debit. Please check these details are correct before clicking Set-up.',
      name: 'Name',
      accountNumber: 'Account number',
      sortCode: 'Sort code',
      referenceNumber: 'Reference number',
      repaymentDate: 'Monthly repayment date',
      directDebitTerms: 'Direct Debit Guarantee',
      confirmText:
        'By clicking Set-up you confirm that you have the authority to setup a Direct Debit on this account',
      statementText: 'Fairlo UK Limited will appear on your statement.',
      submitButton: 'Set-up',
    },
    Setup: {
      title: 'Enter your nominated account details',
      info: 'To make withdrawals and repayments you need to set up your nominated account.',
      sortCodeLabel: 'Sort code',
      sortCodePlaceholder: '00-00-00',
      accountNumberLabel: 'Account number',
      accountNumberPlaceholder: '12345678',
      submitButton: 'Submit',
      dontHaveDifferentAccount: "Don't have a different account",
      loader: 'We are verifying your account. This will only take a moment.',
    },
    RepaymentDate: {
      title: 'Set your repayment date',
      text1: 'This is typically the date you are paid your salary.',
      text2: 'Repayments due on weekends and bank holidays will be made the next working day.',
      label: 'Enter the day of the month (1-31)',
      button: 'Set repayment date',
    },
  },
  Withdrawal: {
    description: 'Select the amount you would like to withdraw into your nominated account.',
    withdrawAmount: 'Withdraw {{amount, currency}}',
    desktopSliderTitle: 'Slide to choose amount',
  },
  Navigation: {
    deposit: 'Additional Repayment',
    monthlyPayment: 'Monthly Repayment',
    withdrawal: 'Withdrawal',
  },
  Products: {
    cards: {
      // TODO(EC-1004): Remove once newProductHomepage is fully rolled out
      usageSummary: {
        total: 'Credit limit:',
        used: 'Outstanding balance:',
        monthlyAmount: 'Monthly repayment:',
        monthlyAmountDetails: '{{amount, currency}} for {{period}} mths',
        interest: 'Annual Interest:',
        nextChargeLabel: 'Next monthly repayment:',
        nextChargeDate: '{{chargeDate, datetime(month: short; day: numeric)}}',
        nextChargeOngoing: 'requested',
      },
      // TODO(EC-1004): Remove once newProductHomepage is fully rolled out
      manualApprovalAccountCard: {
        title: 'Check your email',
        body: 'You are almost there, we just need a few pieces of information to set up your nominated account. Reply to our email.',
      },
      // TODO(EC-1004): Remove once newProductHomepage is fully rolled out
      setupNominatedAccountCard: {
        title: 'Set Up Nominated Account',
        body: 'We need to set up the account where you will receive any withdrawals and make repayments from. Click here.',
      },
      // TODO(EC-1004): Remove once newProductHomepage is fully rolled out
      missingDirectDebitCard: {
        title: 'Missing Direct Debit',
        body: 'Your direct debit mandate is missing. Please click here to set it up to access to your credit limit.',
      },
      // TODO(EC-1004): Remove once newProductHomepage is fully rolled out
      overdue: {
        title: 'Repayment Overdue',
        body: 'You have an overdue balance of {{amount, currency}}. Please click here to catch up and access your credit limit.',
      },
      // TODO(EC-1004): Remove once newProductHomepage is fully rolled out
      transactionPending: {
        title: 'Transaction Pending',
        body: 'Once your previous transaction is confirmed access to your credit limit will be enabled',
      },
      // TODO(EC-1004): Remove once newProductHomepage is fully rolled out
      transactionDelayed: {
        title: 'Transaction Delayed',
        body: 'Once your previous transaction is confirmed access to your credit limit will be enabled',
      },
      // TODO(EC-1004): Remove once newProductHomepage is fully rolled out
      monthlyRepaymentPendingCard: {
        title: 'Monthly Repayment Pending',
        body: 'Your Direct Debit of {{amount, currency}} will be made on {{date, datetime(month: short; day: numeric)}}. Any additional repayments will not replace this repayment.',
      },
      // TODO(EC-1004): Remove once newProductHomepage is fully rolled out
      monthlyRepaymentRetryCard: {
        title: 'Monthly Repayment Retry',
        body: 'Your Direct Debit will be retried for {{amount, currency}} on {{date, datetime(month: short; day: numeric)}}. Any additional repayments will not replace this repayment.',
      },
    },
    features: {
      spinWheel: 'Spin the wheel to select the amount',
    },
    featureDetails: {
      setupFee: 'Setup fee {{amount, currency}}',
      withdrawalFee: 'Withdrawal fee {{amount, currency}}',
      withdrawalFeeZero: 'Withdrawal fee {{amount, currency}} (ord {{regularPrice, currency}})',
      principalLeftLabel: 'New outstanding balance:',
      principalLeftDetails: '{{principalLeft, currency}}',
      principalLeftDetailsWithFees: '{{principalLeft, currency}} including fees',
      monthlyRepaymentLabel: 'New monthly repayment at {{percentage}}:',
      monthlyRepaymentDetails: '{{monthlyAmount, currency}} for {{period}} mths',
      totalRepayableLabel: 'Total repaid:',
      infoText: 'Change repayments anytime to reduce interest cost',
    },
  },
  Deposit: {
    description:
      'Select the amount you would like to repay today, you still need to make your monthly repayment.',
    sliderTitle: 'Slide to choose amount',
    depositButton: 'Repay {{amount, currency}}',
    depositSummary: {
      title: 'Additional Repayment Summary',
      info1: 'This does not replace your monthly repayment.',
      from: 'From:',
      bankLabel: 'Bank',
      accountNumberLabel: 'Account Number',
      sortCodeLabel: 'Sort Code',
      to: 'To:',
      accountNameLabel: 'Account Name',
      paymentReferenceLabel: 'Payment Reference',
      amountLabel: 'Amount',
      info2: 'Only repayments from your nominated account will be accepted.',
      info3:
        'By continuing you are permitting our partner Modulr FS Limited to initiate a payment from your bank account and also agree to their <termsAndConditionsLink>T&C</termsAndConditionsLink> and <privacyPolicyLink>privacy policy</privacyPolicyLink>',
      button: 'Confirm',
    },
    manualDepositDetails: {
      title: 'Manual Repayment Details',
      info1:
        "You'll need to make a bank transfer from your nominated account using the details below.\nThis doesn't replace your monthly repayment.",
      from: 'From:',
      bankLabel: 'Bank',
      sortCodeLabel: 'Sort code',
      accountNumberLabel: 'Account number',
      to: 'To:',
      accountNameLabel: 'Account name',
      paymentReferenceLabel: 'Payment reference',
      amountLabel: 'Amount',
      info2: 'Only payments from your nominated account will be accepted.',
      button: 'Continue',
      copyAccountName: 'Copy account name',
      copySortCode: 'Copy sort code',
      copyAccountNumber: 'Copy account number',
      copyPaymentReference: 'Copy payment reference',
      copyAmount: 'Copy amount',
    },
    maxAmountText:
      'Congrats! This will pay off your total outstanding balance plus {{amount, currency}} interest accrued to today. You will not have any future monthly repayments.',
  },
  MonthlyPayment: {
    description: 'Select the amount you would like to repay each month.',
    changeMonthlyPaymentButton: 'Change amount to {{amount, currency}}',
    desktopSliderTitle: 'Slide to choose amount',
  },
  PaymentProvider: {
    willRedirect: 'We’re securely taking you to your bank. Your security details won’t be shared with us.',
  },
  UserProfile: {
    title: 'My details',
    contactInformation: {
      title: 'Contact information',
      currentAddress: 'Current address',
      addressForm: {
        buildingNumberLabel: 'Building number',
        buildingNameLabel: 'Building name',
        streetLabel: 'Street',
        postCodeLabel: 'Post Code',
        townLabel: 'Town / City',
      },
    },
    endAgreement: 'End my agreement',
    termination: {
      reasonPrompt: 'Please tell us why you are leaving us?',
      formPlaceholder: 'Help us improve by providing more detail',
      reasonOption_NO_LONGER_NEEDED: 'No longer need the product',
      reasonOption_TOO_EXPENSIVE: 'Too expensive',
      reasonOption_SWITCHED_TO_COMPETITOR: 'Switched to a competitor',
      reasonOption_MISSING_FEATURES: 'Missing features',
      reasonOption_OTHER_REASON: 'Other reason',
    },
  },
  EndAgreement: {
    title: 'End your agreement',
    info: "<P>You are able to end your agreement at any time when your outstanding balance is £0.</P><P>When your outstanding balance is £0 you don't pay any interest, but have access to credit up to your limit at any time in the future.</P><P>If you formally end your agreement today then you will no longer be able to access your credit limit.</P>",
    button: 'End agreement',
  },
  MyCredit: {
    whatDoYouWantToDo: 'What do you want to do?',
  },

  FairnessReceipt: {
    heading: 'Fairness Receipt',
    description:
      'See a breakdown of what you pay and what we earn. Ensure your terms are fair, and understand the cost of the money you borrow. You can freely make changes to lower cost or extend time.',
    withdrawalAmount: 'Withdrawal amount',
    newTotalBalance: 'New total balance',
    whatYouPay: 'What you pay',
    interest: 'Interest for {{months}} months',
    principal: 'Principal',
    setupFee: 'Setup fee',
    withdrawalFee: 'Withdrawal fee',
    whatWePay: 'What we pay',
    funding: 'Funding',
    lossProvision: 'Loss provision',
    servicing: 'Servicing',
    labour: 'Labour',
    totalAmount: 'Total amount',
    whatWeMake: 'What we make',
    done: 'Done',
  },
  ApiErrors: {
    loginTookLong: 'Whoops, login timed out, please try again. If the problem persists, please contact us.',
    somethingWentWrong:
      'Whoops something went wrong, please try again. If the problem persists, please contact us',
    inactivity:
      'Whoops, you were logged out due to inactivity, please log back in to continue. If the problem persists, please contact us.',
  },
  Transactions: {
    title: 'Repayment Plan & History',
    planTab: 'Plan',
    historyTab: 'History',
    noHistory: 'There are no transactions',
    noPlanNewUser: 'You haven’t made a withdrawal',
    noPlan: 'You don’t have any upcoming payments',
    detailsTitle: 'Transaction Item',
    transaction: {
      type: {
        DEPOSIT: 'Deposit',
        WITHDRAW: 'Withdrawal',
        PAYBACK: 'Repayment',
        REFUND: 'Refund',
        SETUP_FEE: 'Setup Fee',
      },
      product: {
        CREDIT: '',
      },
      status: {
        INCOMPLETE: 'Upcoming',
        COMPLETE: 'Paid',
        COMPLETE_DEPOSIT: 'Received',
        COMPLETE_WITHDRAW: 'Paid Out',
        CHARGE: 'In-progress',
        OVERDUE: 'Overdue',
      },
      detailType: {
        PRINCIPAL: 'Principal',
        INTEREST: 'Interest',
        OVERDUE_INTEREST: 'Late interest',
        WITHDRAWAL_FEE: 'Withdrawal Fee',
        SETUP_FEE: 'Setup Fee',
        DIRECT_DEBIT_MISSING_FEE: 'Missing Direct Debit',
        REMIT: 'Correction',
        UNKNOWN: 'Unknown',
        TERMINATION: 'Termination',
        CAPITALISED_COST: 'Unpaid interest and fees added to balance',
      },
      feeRemoval: '{{feeType}} returned',
      dueDate: 'Due date',
      completionDate: 'Payment date',
      statusTitle: 'Status',
      totalAmount: 'Total amount',
    },
  },
  Maintenance: {
    title: 'Excuse the mess!',
    text1: 'The website is offline for maintenance.',
    text2: 'We are updating our database and will be back online shortly.',
  },
  ProductSummaryCard: {
    availableLimit: 'Available limit',
    creditLimit: 'Credit limit',
    used: 'Outstanding balance',
    monthlyAmountLabel: 'Monthly repayment',
    monthlyAmountValuePositive: '{{amount, currency}} for {{period}} mths',
    interestRate: 'Annual Interest',
  },
  RepaymentSummaryCard: {
    nextRepayment: 'Next repayment',
    currentRepayment: 'Current repayment',
    ongoing: 'requested',
    nextRepaymentDate: 'on {{date, datetime(month: short; day: numeric)}}',
  },
  ProductHomeShortcuts: {
    title: 'Shortcuts',
    transactionsTitle: 'Transaction history',
    transactionsSubtitle: 'All money in and out, with full details',
  },
  CreditHome: {
    title: 'Hello <private>{{username}}</private>!',
    availableAmount: 'You can withdraw',
    outOfCreditLimit: 'of {{amount, currency}}',
    amountUsed: 'Amount used: {{amount, currency(displayDecimals: false)}}',
    amountUsedPrefix: 'Amount used: ',
    withdraw: 'Withdraw money',
    deposit: 'Make a payment',
  },
  Notifications: {
    overdue: {
      title: 'Payment overdue.',
      description: 'Pay {{amount, currency}} to avoid further charges and reopen your credit.',
    },
    transactionPending: {
      title: 'Transaction in progress.',
      description: 'Please wait a few minutes before making another withdrawal or payment.',
    },
    transactionDelayed: {
      title: 'Bank connection delayed.',
      description: 'Please try again in 30 minutes.',
    },
    missingDirectDebit: {
      title: 'Direct debit missing.',
      description: 'Set it up to access your credit limit.',
    },
    setupNominatedAccount: {
      title: 'Set up your nominated account.',
      description: 'This is where withdrawals and repayments go.',
    },
    manualApprovalAccount: {
      title: 'Check your email.',
      description: 'Reply to finish setting up your nominated account.',
    },
    monthlyRepaymentPending: {
      title: 'Repayment pending.',
      description:
        "Your Direct Debit runs on {{date, datetime(month: short; day: numeric)}}. Extra repayments won't replace it.",
    },
    monthlyRepaymentRetry: {
      title: 'Repayment retry.',
      description:
        "We'll retry your Direct Debit on {{date, datetime(month: short; day: numeric)}}. Extra repayments won't replace it.",
    },
  },
  RepaymentCard: {
    toggleNextPaymentDetails: 'Toggle next payment details',
    nextRepayment: 'Next payment: {{date, datetime(month: short; day: numeric)}}',
    debtFreeIn_one: 'Debt-free in about {{count}} month',
    debtFreeIn_other: 'Debt-free in about {{count}} months',
    changeMonthlyPaymentButtonShort: 'Change',
    leftToPay: 'Remaining to pay: about {{amount, currency}}',
    basedOnCurrentRepaymentPlan: '(Based on current repayment plan)',
    paymentPlanButton: 'View my full payment plan',
    changeMonthlyPaymentButton: 'Change my monthly amount',
    interest: '{{label}} ({{rate}})',
    principal: 'Pay down debt',
  },
} as const;

export default english;
